import { PropType } from '@vue/composition-api';
import { IVScrollItem } from '../types';

export const DEFAULT_BUFFER_SIZE = 2;
export const DEFAULT_ITEM_SIZE = 100;
export const DEFAULT_RENDER_DELAY = 100;
export const DEFAULT_SCROLL_ANIMATION_DURATION = 400;

export const BASE_VIRTUAL_SCROLL_PROPS = {
  /** Each item in a list will receive own item as "data" */
  items: {
    type: Array as PropType<IVScrollItem[]>,
    default: (): IVScrollItem[] => [],
  },
  /** All items will receive this shared context */
  context: {
    type: Object,
    required: false,
    default: undefined,
  },
  /** Amount of items that can be rendered before and after viewport */
  buffer: {
    type: Number,
    default: 2,
  },
  dataKey: {
    type: String,
    default: 'id',
  },
  defaultItemSize: {
    type: Number,
    default: 100,
  },
  activeItemId: {
    type: [Number, String],
    default: undefined,
  },
  isScrolling: {
    type: Boolean,
    default: false,
  },
  unpinActiveItem: {
    type: Boolean,
    default: false,
  },
};
